import { render, staticRenderFns } from "./payPlatform.vue?vue&type=template&id=5b6fa8ad&scoped=true"
import script from "./payPlatform.vue?vue&type=script&lang=js"
export * from "./payPlatform.vue?vue&type=script&lang=js"
import style0 from "./payPlatform.vue?vue&type=style&index=0&id=5b6fa8ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6fa8ad",
  null
  
)

export default component.exports